import { useState, useEffect } from 'react';
import axios from 'axios';

export default function CustomerInfoForm({
    phoneNumber,
    businessName,
    salePointName,
    onStateChange,
    onDistrictChange,
    onCustomerInfoChange,
    initialValues = {}
}) {
     const [custName, setCustName] = useState(initialValues.custName || '');
    const [address, setAddress] = useState(initialValues.address || '');
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState('');
    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState('');

    useEffect(() => {
        axios.get('/api/states/active')
            .then(response => {
                setStates(response.data);
            })
            .catch(error => {
                console.error('Error fetching states:', error);
            });
    }, []);

    useEffect(() => {
        if (!selectedState) return;

        axios.get(`/api/${businessName}/${salePointName}/states/${selectedState}/districts`)
            .then(response => {
                setDistricts(response.data);
                setSelectedDistrict('');
                onDistrictChange('');
            })
            .catch(error => {
                console.error('Error fetching districts:', error);
            });
    }, [selectedState, businessName, salePointName]);

    useEffect(() => {

        onCustomerInfoChange({
            custName,
            phoneNumber,
            address,
            state: selectedState,
            district: selectedDistrict
        });
    }, [custName, address, selectedState, selectedDistrict]);

    return (
        <div className="customer-info-section">
            <input
                type="text"
                placeholder="الأسم كاملا"
                value={custName}
                onChange={(e) => setCustName(e.target.value)}
                className="full-name-input"
                required
            />
            
            <div className="location-selectors">
                <select
                    value={selectedState}
                    onChange={(e) => {
                        setSelectedState(e.target.value);
                        onStateChange(e.target.value);
                    }}
                    className="state-select"
                    required
                >
                    <option value="">أختر المحافظة</option>
                    {states.map(state => (
                        <option key={state.id} value={state.code}>
                            {state.nameAr}
                        </option>
                    ))}
                </select>

                <select
                    value={selectedDistrict}
                    onChange={(e) => {
                        setSelectedDistrict(e.target.value);
                        onDistrictChange(e.target.value);
                    }}
                    className="district-select"
                    disabled={!districts.length}
                    required
                >
                    <option value="">أختر المدينة</option>
                    {districts.map((district) => (
                        <option key={district.transportDistrictId} value={district.transportDistrictId}>
                            {district.name}
                        </option>
                    ))}
                </select>
            </div>

            <input
                type="text"
                placeholder="العنوان كاملا"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                className="address-input"
                required
            />
        </div>
    );
}
